/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_New_Ladybug_FryInputs */

const fr_agent_new_ladybug_fry = /** @type {(inputs: Agent_New_Ladybug_FryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut`)
};

/**

* @param {Agent_New_Ladybug_FryInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const agent_new_ladybug_fry = /** @type {((inputs?: Agent_New_Ladybug_FryInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_New_Ladybug_FryInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_agent_new_ladybug_fry(inputs)
});